import React from "react"

const WorldPayNotify = () => {
  return <div>WorldPayNotify</div>
}

export default WorldPayNotify
